import Link from 'next/link';

import Modal from 'components/common/Modal';

import * as S from './styles';

export function AboutFreeFreight({ setShowModalFreeFreight }) {
  return (
    <Modal onClose={() => setShowModalFreeFreight(false)}>
      <S.Container className="about-free-freight">
        <span className="frete-gratis-tarja">Frete Grátis</span>

        <span className="regulation-info">
          Ao navegar pelo site você verá que muitos produtos possuem este selo,
          isto quer dizer que são itens elegíveis de Frete Grátis, porém, apenas
          em compras a partir de R$ 100,00 (cem reais) e com peso de até 1kg.
        </span>

        <Link href="/pagina/sobre-frete-gratis">
          <a className="link-more-information">
            Clique aqui para mais informações
          </a>
        </Link>
      </S.Container>
    </Modal>
  );
}
